import { userService } from '../_services';

export const userLocations = {
    namespaced: true,
    state: {
        all: {},
        active: null,
        ready: false
    },
    actions: {
        getUserLocations({ commit }) {
            commit('getAllRequest');
            return new Promise((resolve, reject) => {

                userService.getUserLocations()
                    .then(
                        userLocations => {
                            commit('getAllSuccess', userLocations);
                            resolve(userLocations);
                        },
                        error => {
                            commit('getAllFailure', error);
                            reject(error);
                        }

                    );
            })
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
            state.active = null;
            state.ready = false;
        },
        getAllSuccess(state, userLocations) {
            state.all = userLocations['hydra:member'];
            state.active = null;
            state.ready = true;
        },
        getAllFailure(state, error) {
            state.all = { error };
            state.active = null;
            state.ready = false;
        }
    },
    getters: {
        showUserLocations(state) {
            return state.all;
        },
        showUserLocationByIRI(state) {
            return iri => {
                return state.all.find(obj => obj['@id'] === iri)
            }
        },
        showUserLocationsByUser(state) {
            return userid => {
                return state.all.filter(obj => obj.user.id === userid)
            }
        },
        showUserLocationsByUserIRI(state) {
            return useriri => {
                return state.all.filter(obj => obj.user['@id'] === useriri)
            }
        },
        isLoading(state) {
            return (state.all.loading);
        },
        isReady(state) {
            return (state.ready);
        }
    }
};
